const UserArchival = () => {
  return <div></div>;
};

export default UserArchival;
